var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"overlay-accept text-center"},[_c('div',{staticClass:"content white"},[_c('check-icon',{attrs:{"size":190}}),_c('h1',[_vm._v(_vm._s(_vm.heading))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }